import { Children, cloneElement, isValidElement, type ReactNode } from 'react';
import './sidebar.css';

export interface SidebarSubNavProps {
  parentTo: string;
  parentLabel: string;
  children: ReactNode;
}

export function SidebarSubNav({ parentLabel, children }: SidebarSubNavProps) {
  return (
    <div className="sidebar-sub-nav">
      <div className="sidebar-sub-nav__parent">{parentLabel}</div>
      {Children.map(children, (child) => {
        if (!isValidElement(child)) return child;
        return (
          <div className="sidebar-sub-nav__child">
            {cloneElement(child)}
          </div>
        );
      })}
    </div>
  );
}
